import { render, staticRenderFns } from "./collectionLedger.vue?vue&type=template&id=549186dc&scoped=true"
import script from "./collectionLedger.vue?vue&type=script&lang=js"
export * from "./collectionLedger.vue?vue&type=script&lang=js"
import style0 from "./collectionLedger.vue?vue&type=style&index=0&id=549186dc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549186dc",
  null
  
)

export default component.exports